import {
    CORE_LOAD_SETTING_SUCCESS,
    CORE_LOAD_SETTING_REQUEST,

} from '../../types'

const initialState = []
export default {
    setting: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_SETTING_REQUEST:
                return initialState

            case CORE_LOAD_SETTING_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}

            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/setting/reducer.js